import React, { useEffect, useState } from 'react'
import { Box, Button, useMediaQuery, useTheme } from '@mui/material'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome' // LAP — entrée Conseiller en Organisation
import { useNavigate } from 'react-router-dom' // LAP — navigation vers /conseiller-organisation
import Chart1 from './Chart1Dout'
import Chart3 from './Chart3HBar'
import Chart2 from './Chart2VBar'
import TypeWidgets from './TypeWidgets'
import urls from 'utils/urls'
import { makeGetRequest } from 'utils/api'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export default function SyntheseTaches({ open, handleMesTaches, updateSynthese, updateTodo }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const navigate = useNavigate() // LAP — vers le Conseiller en Organisation
  const [tasks, setTasks] = useState([])
  // LAP — filtre par type de tâche appliqué aux 3 graphes existants
  const [typeFilter, setTypeFilter] = useState('all')
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  useEffect(() => {
    fetchTasks()
  }, [updateSynthese])
  // useEffect(() => {
  //   fetchTasks()
  // }, [])
  const fetchTasks = async () => {
    // include_done=1 : la synthèse a besoin des tâches terminées (donut « Terminées », graphe Eisenhower)
    const { data, status } = await makeGetRequest(
      urls.fetchTasks + '?limit=1000000&include_done=1',
      {},
      true,
    )
    if (status === 200) {
      setTasks(data)
    }
  }

  // Tâches alimentant les graphes : filtrées par type (sauf "all")
  const filteredTasks =
    typeFilter === 'all' ? tasks : tasks.filter((v) => v.TypeTache === typeFilter)

  const typeFilters = [
    { id: 'all', label: t('mesToDo.filterAll') },
    { id: 'livrable', label: t('mesToDo.typeLivrable') },
    { id: 'habitude', label: t('mesToDo.typeHabitude') },
    { id: 'competence', label: t('mesToDo.typeCompetence') },
    { id: 'kpi', label: t('mesToDo.typeKpi') },
  ]

  // LAP — style de carte unifié (aligné sur la DA sombre validée : bordure
  // subtile, radius généreux, léger dégradé, ombre douce)
  const cardSx = {
    background: 'linear-gradient(180deg, #0a4173 0%, #083b67 100%)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: '20px',
    padding: '16px',
    boxShadow: '0 8px 24px rgba(0,0,0,0.25)',
  }
  // Titre de section discret en tête de chaque carte
  const cardTitleSx = {
    fontSize: '11px',
    fontWeight: 700,
    letterSpacing: '1px',
    textTransform: 'uppercase',
    color: 'rgba(255,255,255,0.55)',
    marginBottom: '10px',
  }

  return (
    // <Box sx={{ width: open ? '85%' : '100%' }}>
    <Box display={'flex'} flexDirection={'column'} width={'100%'} mb={2}>
      {/* LAP — entrée vers le Conseiller en Organisation IA (note/évalue le
          profil d'organisation : domaines, projets, complétion, objectifs).
          Calqué sur le bouton « Maître du temps » du calendrier. */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          padding: isMobile ? '0 5px 10px' : '0 25px 10px',
        }}
      >
        <Button
          variant="contained"
          startIcon={<AutoAwesomeIcon />}
          onClick={() => navigate('/conseiller-organisation')}
          sx={{ textTransform: 'none' }}
        >
          {t('conseillerOrganisation.entryButton', {
            defaultValue: 'Conseiller en organisation',
          })}
        </Button>
      </Box>
      {/* LAP — filtre par type de tâche */}
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 1,
          padding: isMobile ? '0 5px 10px' : '0 25px 10px',
        }}
      >
        {/* LAP — filtres en « pills » arrondies, plus douces que les boutons carrés */}
        {typeFilters.map((f) => (
          <Button
            key={f.id}
            size="small"
            disableElevation
            variant={typeFilter === f.id ? 'contained' : 'outlined'}
            onClick={() => setTypeFilter(f.id)}
            sx={{
              textTransform: 'none',
              borderRadius: '999px',
              padding: '3px 14px',
              fontWeight: 600,
              ...(typeFilter !== f.id && {
                color: 'rgba(255,255,255,0.85)',
                borderColor: 'rgba(255,255,255,0.25)',
                background: 'rgba(255,255,255,0.05)',
                ':hover': {
                  borderColor: 'rgba(255,255,255,0.5)',
                  background: 'rgba(255,255,255,0.1)',
                },
              }),
            }}
          >
            {f.label}
          </Button>
        ))}
      </Box>
      <Box
        className=""
        sx={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          // display: 'grid',
          // gridTemplateColumns: { md: '0.5fr 2fr' },
          padding: isMobile ? '0 5px' : '0 25px',
          // gridGap: '10px',
          gap: 2,
        }}
      >
        <Box
          sx={{
            ...cardSx,
            width: isMobile ? '100%' : '25%',
            // LAP — la carte s'adapte au contenu (donut + légende) : hauteur
            // mini alignée sur la carte Eisenhower, mais jamais figée pour
            // éviter que la légende déborde de la carte
            height: 'auto',
            minHeight: isMobile ? 'auto' : 410,
          }}
        >
          <Box sx={cardTitleSx}>
            {t('mesToDo.cardStatuses', { defaultValue: 'Répartition par statut' })}
          </Box>
          <Chart1 tasks={filteredTasks} handleMesTaches={handleMesTaches} />
        </Box>
        <Box
          sx={{
            ...cardSx,
            width: open ? (isMobile ? '100%' : '70%') : '100%',
            height: 410,
          }}
        >
          <Box sx={cardTitleSx}>
            {t('mesToDo.cardPriorities', { defaultValue: 'Priorités (Eisenhower)' })}
          </Box>
          <Chart2 tasks={filteredTasks} handleMesTaches={handleMesTaches} />
        </Box>
      </Box>
      <Box
        className=""
        sx={{
          // display: 'grid',
          // gridTemplateColumns: { sm: '1fr' },
          padding: isMobile ? '0 5px' : '0 25px',
          width: open ? (isMobile ? '100%' : '96%') : '100%',
          marginTop: '10px',
        }}
      >
        <Box sx={{ ...cardSx, width: '100%' }}>
          <Box sx={cardTitleSx}>
            {t('mesToDo.cardDeadlines', { defaultValue: 'Par échéance' })}
          </Box>
          <Chart3 tasks={filteredTasks} handleMesTaches={handleMesTaches} updateTodo={updateTodo} />
        </Box>
      </Box>
      {/* LAP — widgets dédiés au suivi par type (habitudes / compétences / KPI).
          On garde le comportement d'avant include_done : uniquement les tâches actives. */}
      <TypeWidgets tasks={tasks.filter((v) => v.Statut !== 'Fait' && !v.Done)} />
    </Box>
  )
}
